var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { isErrorHTTP, isSuccessHTTP } from 'boost-api/APIRestClient';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { css, html, LitElement } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { router } from '../router/BoostPortalRouter';
import { BoostButton } from '../components/common/BoostButton';
import { BoostPortalChooseDepartment } from '../components/BoostPortalChooseDepartment';
import { BoostPortalPersonalInformation } from '../components/BoostPortalPersonalInformation';
import { BoostStepIndicator, } from '../components/common/BoostStepIndicator';
import { BoostPortalSponsorConfirm } from '../components/BoostPortalSponsorConfirm';
import { BoostPortalSponsorProgress } from '../components/BoostPortalSponsorProgress';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
import { BoostPortalParamsHandler } from '../helpers/BoostPortalParamsHandler';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
import { BoostPortalNavigationSteps } from '../enums/BoostPortalNavigationSteps';
let BoostPortalRegisterSponsorView = class BoostPortalRegisterSponsorView extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    constructor() {
        super(...arguments);
        this.currentStep = BoostPortalNavigationSteps.DEPARTMENT;
        this.sponsoredId = 0;
        this.connectionHash = '';
    }
    static get is() {
        return 'boost-portal-register-sponsor-view';
    }
    static get styles() {
        return css `
            :host {
                padding: 3rem;
                width: 100%;
            }

            h3 {
                color: var(--boost-font-color-dark);
                font-weight: 500;
                margin-bottom: 10px;
            }
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this._onConnectedCallback();
    }
    _onConnectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateComplete;
            const sponsorConnectionHash = BoostPortalParamsHandler.getParameter('sponsorConnectionHash');
            if (sponsorConnectionHash) {
                this.connectionHash = sponsorConnectionHash;
                this.sponsoredId = parseInt(sponsorConnectionHash);
                const sponsoredMember = yield MembersignupAPI.getV1BoostsignupSponsed({
                    sponsorConnectionHash,
                });
                if (isSuccessHTTP(sponsoredMember)) {
                    this.sponsoredMember = sponsoredMember;
                }
                else if (isErrorHTTP(sponsoredMember)) {
                    console.error(sponsoredMember.error);
                }
            }
        });
    }
    /** @override */ render() {
        return html `
            <boost-portal-header .viewLoginButton=${false}></boost-portal-header>

            <boost-step-indicator
                .currentStep="${this.currentStep}"
                .steps="${this._getSteps(this.currentStep)}"
                @currentStep-changed="${(event) => {
            this.currentStep = event.detail.currentStep;
        }}"
            ></boost-step-indicator>

            ${this._showViewForCurrentStep(this.currentStep)}
        `;
    }
    _createSponsorMember(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const buttonElement = event.target;
            if (buttonElement.disabled) {
                return;
            }
            if (!this.memberInformation || !this._isValidMemberInformation() || !this.selectedDepartmentId) {
                return;
            }
            this.memberInformation.is_sponsor = true;
            this.memberInformation.departmentId = this.selectedDepartmentId;
            this.memberInformation.netsCallbackUrl =
                router.baseUrl + this.centerShort + '/avtalegiro?departmentId=' + this.selectedDepartmentId;
            this.requestUpdate('memberInformation');
            this.sponsorInformation = this.memberInformation;
            this.sponsorInformation.acceptanceCallbackUrl = router.baseUrl + this.centerShort + '/sponsor/accept';
            this.sponsorInformation.sponsorConnectionHash = this.connectionHash;
            buttonElement.setLoading(true);
            const createdMemberResult = yield MembersignupAPI.postV1BoostsignupSponsor(this.sponsorInformation);
            buttonElement.setLoading(false);
            if (isErrorHTTP(createdMemberResult)) {
                if (createdMemberResult.error.http_status === 409 &&
                    createdMemberResult.error.message === 'Member already exists.') {
                    SnackBar.push({ type: 'danger', title: 'Medlem eksisterer allerede' });
                }
                else {
                    SnackBar.pushError(createdMemberResult.error);
                }
                return;
            }
            this.memberInformation = createdMemberResult;
            this.dispatch(BoostPortalStore.Actions.SetMemberInformation(this.memberInformation));
            this.currentStep = BoostPortalNavigationSteps.SUCCESS;
        });
    }
    _getSteps(currentStep) {
        const steps = [
            {
                title: 'Avdeling',
                isActive: currentStep === BoostPortalNavigationSteps.DEPARTMENT,
                subtitle: '',
            },
            {
                title: 'Personalia',
                isActive: currentStep === BoostPortalNavigationSteps.INFORMATION,
                subtitle: '',
            },
            {
                title: 'Bekreft',
                isActive: currentStep === BoostPortalNavigationSteps.SUCCESS,
                subtitle: '',
            },
        ];
        return steps;
    }
    _isValidMemberInformation() {
        if (!this.memberInformation || !this.boostPortalPersonalInformation) {
            return false;
        }
        return this.boostPortalPersonalInformation.validateFields();
    }
    _showViewForCurrentStep(currentStep) {
        var _a;
        switch (currentStep) {
            case BoostPortalNavigationSteps.DEPARTMENT:
                return html `
                    <boost-portal-choose-department></boost-portal-choose-department>

                    <div>
                        <boost-button
                            type="submit"
                            name="${this.boostTranslate('next-button')}"
                            @click="${() => (this.currentStep = BoostPortalNavigationSteps.INFORMATION)}"
                            ?disabled="${!this.selectedDepartmentId}"
                            width-full
                        ></boost-button>
                    </div>
                `;
            case BoostPortalNavigationSteps.INFORMATION:
                return html `
                    <boost-portal-personal-information
                        id="boostPortalPersonalInformation"
                        hide-summary-box
                        .sponsoredMember="${(_a = this.sponsoredMember) !== null && _a !== void 0 ? _a : undefined}"
                        ?isSponsor="${true}"
                        @memberIsUnderaged-changed="${(event) => {
                    this.memberIsUnderaged = event.detail.memberIsUnderaged;
                }}"
                    ></boost-portal-personal-information>

                    ${this.memberIsUnderaged
                    ? html `
                              <boost-status-container type="info">
                                  ${this.boostTranslate('sponsor-under-age')}
                              </boost-status-container>
                          `
                    : html `
                              <boost-button
                                  type="submit"
                                  name="${this.boostTranslate('next-button')}"
                                  @click="${this._createSponsorMember}"
                                  ?disabled="${!this.memberInformation}"
                                  width-full
                              ></boost-button>
                          `}
                `;
            case BoostPortalNavigationSteps.SUCCESS:
                return html ` <boost-portal-sponsor-confirm></boost-portal-sponsor-confirm> `;
        }
    }
};
BoostPortalRegisterSponsorView._deps = [
    BoostButton,
    BoostStepIndicator,
    BoostPortalChooseDepartment,
    BoostPortalPersonalInformation,
    BoostPortalSponsorProgress,
    BoostPortalSponsorConfirm,
];
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    property({ type: String }),
    __metadata("design:type", String)
], BoostPortalRegisterSponsorView.prototype, "centerShort", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Number)
], BoostPortalRegisterSponsorView.prototype, "currentStep", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('memberInformation')),
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterSponsorView.prototype, "memberInformation", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterSponsorView.prototype, "sponsorInformation", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedDepartmentId')),
    property({ type: Number }),
    __metadata("design:type", Number)
], BoostPortalRegisterSponsorView.prototype, "selectedDepartmentId", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Boolean)
], BoostPortalRegisterSponsorView.prototype, "memberIsUnderaged", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], BoostPortalRegisterSponsorView.prototype, "sponsoredMember", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Number)
], BoostPortalRegisterSponsorView.prototype, "sponsoredId", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], BoostPortalRegisterSponsorView.prototype, "connectionHash", void 0);
__decorate([
    query('#boostPortalPersonalInformation'),
    __metadata("design:type", BoostPortalPersonalInformation)
], BoostPortalRegisterSponsorView.prototype, "boostPortalPersonalInformation", void 0);
BoostPortalRegisterSponsorView = __decorate([
    customElement(BoostPortalRegisterSponsorView.is)
], BoostPortalRegisterSponsorView);
export { BoostPortalRegisterSponsorView };
